/*
 * � 2020 Microsoft. All rights reserved.
 */

define(
    'SolitaireShared/KlondikeLogic/ChallengeAuthorities/AchieveScoreDailyKlondikeAuthority',[
        'SolitaireShared/KlondikeLogic/KlondikeAuthority',
        'SolitaireShared/KlondikeLogic/IDailyKlondikeAuthority',
        'SolitaireShared/CardLogic/IDailyAuthority',
        'SolitaireShared/CardLogic/IAchieveScoreDailyAuthority',
        'SolitaireShared/CardLogic/ChallengeConstants'
    ],
    function (KlondikeAuthority, IDailyKlondikeAuthority, IDailyAuthority, IAchieveScoreDailyAuthority, ChallengeConstants) {
        "use strict";

        var AchieveScoreDailyKlondikeAuthority = function (param) {
            this.initAchieveScoreDailyKlondikeAuthority(param);
        };

        AchieveScoreDailyKlondikeAuthority.constructor = AchieveScoreDailyKlondikeAuthority;
        AchieveScoreDailyKlondikeAuthority.prototype = Object.create(IDailyKlondikeAuthority.prototype);
        IAchieveScoreDailyAuthority.call(AchieveScoreDailyKlondikeAuthority.prototype);

        AchieveScoreDailyKlondikeAuthority.prototype.initAchieveScoreDailyKlondikeAuthority = function (param) {
            IDailyKlondikeAuthority.call(this);

            if (param != null && param[ChallengeConstants.KeyScoreRequired])
                this.ScoreRequired = parseInt(param[ChallengeConstants.KeyScoreRequired]);
            else throw "Invalid parameter passed in creating Daily Challenge";

            this.ChallengeType = IDailyAuthority.ChallengeType.AchieveScore;
        };

        AchieveScoreDailyKlondikeAuthority.prototype.IsGameWon = function () {
            return (!this.CardSupply.WaitingForAnimation) && this.GetIsGameWon();
        };

        AchieveScoreDailyKlondikeAuthority.prototype.GetIsGameWon = function () {
            return this.CardSupply.Score >= this.ScoreRequired;
        };

        return AchieveScoreDailyKlondikeAuthority;
    }
);
